import { ApiHosts, handleResponseOld, makeGet } from '@/redux/api/helpers';
import { FetchRelatedSearchesResponse, RelatedSearchItem } from './relatedSearches.types';

const SIZE = 50;

type GetRelatedSearchesParams = {
    deployment: string;
    query: string;
    size?: number;
};

/** Search-party response envelope: { error, payload: { relatedSearches, total } } */
export type SearchPartyRelatedSearchesEnvelope = {
    error?: boolean;
    payload?: { relatedSearches?: RelatedSearchItem[]; total?: number };
};

function transformSearchPartyResponse(body: SearchPartyRelatedSearchesEnvelope): FetchRelatedSearchesResponse {
    return {
        relatedSearches: body.payload?.relatedSearches ?? [],
    };
}

/**
 * Fetches related search suggestions from search-party for SRP. Server-only (used from SSR loadData).
 * GET with query params size and query. Returns { error, payload: { relatedSearches, total } }.
 * @see https://search-party-DEPLOYMENT.liveauctioneers.com/search/relatedsearches
 */
export const getRelatedSearches = ({
    deployment,
    query,
    size = SIZE,
}: GetRelatedSearchesParams): Promise<FetchRelatedSearchesResponse> => {
    return new Promise((resolve, reject) => {
        const request = makeGet({
            apiPath: 'relatedsearches',
            deployment,
            path: ApiHosts.Search,
            queryParams: { query, size },
        });

        request.end((err, response) => {
            handleResponseOld<SearchPartyRelatedSearchesEnvelope, FetchRelatedSearchesResponse>({
                err,
                reject,
                resolve,
                response,
                transform: transformSearchPartyResponse,
            });
        });
    });
};
